module.exports = __webpack_public_path__ + "fonts/element-icons.1f3c0d8.ttf";